"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const sdk_constants_1 = require("../../constants/sdk.constants");
class SignatureClient {
    static newInstance(options, retryOptions) {
        return new SignatureClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions));
    }
    constructor(client) {
        this.client = client;
    }
    async signPreviewAssessmentRequest(assessmentId, config, headers) {
        const response = await this.client.post(`${sdk_constants_1.ENGINE_API_PREFIX}/signature.previewAssessment`, { assessmentId, config }, { headers });
        return response.body.data;
    }
    async signMonitorAssessmentRequest(assessmentId, report, headers) {
        const response = await this.client.post(`${sdk_constants_1.ENGINE_API_PREFIX}/signature.monitorAssessment`, { assessmentId, reports: [report] }, { headers });
        return response.body.data;
    }
    async signPlayAttemptRequest(attemptId, config, headers) {
        const response = await this.client.post(`${sdk_constants_1.ENGINE_API_PREFIX}/signature.playAttempt`, { attemptId, config }, { headers });
        return response.body.data;
    }
    async signReviewAttemptRequest(attemptId, items, renderingType, config, assigneeId, headers) {
        const response = await this.client.post(`${sdk_constants_1.ENGINE_API_PREFIX}/signature.reviewAttempt`, { attemptId, items, config, renderingType, assigneeId }, { headers });
        return response.body.data;
    }
    async signPreviewRubricRequest(attemptId, externalItemId, responses, headers) {
        const response = await this.client.post(`${sdk_constants_1.ENGINE_API_PREFIX}/signature.previewRubric`, { attemptId, externalItemId, responses }, { headers });
        return response.body.data;
    }
    async signStudentDetailReportRequest(attemptId, items, config, headers) {
        const response = await this.client.post(`${sdk_constants_1.ENGINE_API_PREFIX}/signature.studentDetailReport`, { attemptId, items, config }, { headers });
        return response.body.data;
    }
}
exports.SignatureClient = SignatureClient;
//# sourceMappingURL=signature.client.js.map